module.exports = __webpack_public_path__ + "img/clogo.3345f5ca.png";